import { render } from "./AsignacionMedicamentos.vue?vue&type=template&id=7e966af6&scoped=true"
import script from "./AsignacionMedicamentos.vue?vue&type=script&lang=js"
export * from "./AsignacionMedicamentos.vue?vue&type=script&lang=js"

import "./AsignacionMedicamentos.vue?vue&type=style&index=0&id=7e966af6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e966af6"]])

export default __exports__